/* tslint:disable */
/* eslint-disable */
export enum CharterContractReportDateTypes {
  Departure = 'DEPARTURE',
  Arrival = 'ARRIVAL',
  Contractdate = 'CONTRACTDATE',
}
